/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MakeupStatus = {
    Pending: 'Pending',
    Approved: 'Approved',
    ChangeRequested: 'ChangeRequested',
    Rejected: 'Rejected',
    Cancelled: 'Cancelled'
} as const;
export type MakeupStatus = typeof MakeupStatus[keyof typeof MakeupStatus];


export function instanceOfMakeupStatus(value: any): boolean {
    for (const key in MakeupStatus) {
        if (Object.prototype.hasOwnProperty.call(MakeupStatus, key)) {
            if (MakeupStatus[key as keyof typeof MakeupStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MakeupStatusFromJSON(json: any): MakeupStatus {
    return MakeupStatusFromJSONTyped(json, false);
}

export function MakeupStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MakeupStatus {
    return json as MakeupStatus;
}

export function MakeupStatusToJSON(value?: MakeupStatus | null): any {
    return value as any;
}

export function MakeupStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): MakeupStatus {
    return value as MakeupStatus;
}

